import { ConnectorGlyph } from '@/components/points/ConnectorGlyph';
import { connectorsByType } from '@/lib/connectorGroups';
import type { StationDetailOut } from '@/api/stations';

/** Disponibilidade compacta por tipo de conector — símbolo + livres/total,
 * porte de `mapfirst-a.jsx` · `ConnectorAvail`, usado no peek do mapa. */
export function ConnectorAvailPills({ station }: { station: StationDetailOut }) {
  const groups = connectorsByType(station);
  if (groups.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {groups.map((g) => {
        const free = g.free > 0;
        return (
          <span
            key={g.type}
            className="inline-flex items-center gap-1 rounded-full px-2 py-1 text-[11px] font-semibold"
            style={{
              background: free ? 'rgba(0,192,114,0.12)' : 'rgba(0,27,116,0.06)',
              color: free ? '#008A4F' : 'rgba(0,27,116,0.55)'
            }}
          >
            <ConnectorGlyph type={g.type} size={11} color={free ? '#008A4F' : 'rgba(0,27,116,0.55)'} />
            {g.free}/{g.total}
          </span>
        );
      })}
    </div>
  );
}
